import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function WebDesigningServices() {
  const faqs = [
    {
      question: "What web design services does Mokshiq provide?",
      answer: "We design UI/UX prototypes, modern responsive websites, corporate portals, CMS platforms (WordPress/Custom React), and landing pages."
    },
    {
      question: "Are the designs mobile responsive and fast loading?",
      answer: "Yes, every website built by Rakle Service Private Limited is 100% mobile-responsive, SEO optimized, and scores 90+ on Google PageSpeed Insights."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-laptop-code me-2"></i>Design &amp; Web
            </span>
            <h1 className="page_title text-white mb-3">Web Designing &amp; CMS Development</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Custom responsive website design, UI/UX architecture, and CMS platforms by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a></li>
              <li className="active"><a href="#!">Web Designing Services</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-compass-drafting text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">UI/UX Design</h3>
                  <p className="text-muted small">User-centered Figma wireframing, interactive prototyping, and modern dark-mode fintech interfaces.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-code text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">CMS Development</h3>
                  <p className="text-muted small">WordPress, headless CMS, and custom React admin portals for easy content editing.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-rocket text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Performance Optimization</h3>
                  <p className="text-muted small">Clean CSS/JS code minification, webp image compression, and SSL certificate installation.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Web Designing FAQs" subtitle="Frequently asked questions about website design and CMS development." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default WebDesigningServices;
